export default __webpack_public_path__ + "media/images/iui/listGroup-7dd73b318aee25bf74c32eaa003c7220.png";